import { z } from 'zod';
import { isValidCpf } from '../utils/isValidCpf';
import { isValidCnpj } from '../utils/isValidCnpj';

export const FarmerSchema = z.object({
	name: z.string().min(1, 'Nome é obrigatório'),
	surName: z.string().min(1, 'Sobrenome é obrigatório'),
	document: z
		.string()
		.min(1, 'CPF/CNPJ é obrigatório')
		.superRefine((v, ctx) => {
			const digits = v.replace(/\D/g, '');
			if (digits.length !== 11 && digits.length !== 14) {
				ctx.addIssue({ code: 'custom', message: 'CPF/CNPJ deve ter 11 ou 14 dígitos' });
				return;
			}
			const isValid = digits.length === 11 ? isValidCpf(digits) : isValidCnpj(digits);
			if (!isValid) {
				ctx.addIssue({ code: 'custom', message: 'CPF/CNPJ inválido' });
			}
		}),
	phoneNumber: z
		.string()
		.nullish()
		.refine(v => !v || v.replace(/\D/g, '').length >= 10, 'Telefone inválido'),
	email: z.email().or(z.literal('')).optional(),
	status: z.enum(['true', 'false'], { error: 'Status é obrigatório' }),
});

export type FarmerSchemaType = z.infer<typeof FarmerSchema>;
